import React from "react";
import "./organization-link-item.scss";

import { GSInfoGroup, GSButton } from "golfstatus_react_components";
import { faTimesCircle, faGlobe } from "@fortawesome/free-solid-svg-icons";
import {faInstagram, faTwitter, faFacebook, faTwitch, faPinterest, faYoutube} from '@fortawesome/free-brands-svg-icons'

const OrganizationLinkItem = (props) => {
  const {
    id,
    website,
    removeLink
  } = props;
  const getIcon = () => {
    if(website.includes('instagram'))
    {
      return faInstagram
    }
    else if (website.includes('twitter'))
    {
      return faTwitter
    }
    else if(website.includes('facebook'))
    {
      return faFacebook
    }
    else if (website.includes('twitch'))
    {
      return faTwitch
    }
    else if(website.includes('pinterest'))
    {
      return faPinterest
    }
    else if(website.includes('youtube'))
    {
      return faYoutube
    }
    else{
      return faGlobe
    }
  }
  const getInfoGroup = () => {
    let icon = {
      
      sections: [
        {
          sectionItems: [{ type: "primary", value: <GSButton buttonIcon={getIcon()} /> }],
        },
      ],
    };

    let link = {
      fit: "stretch",
      sections: [
        {
          sectionItems: [
            { type: "secondary underlined", value: website },
          ],
        },
      ],
    };

    let remove = {
      sections: [
        {
          sectionItems: [
            { type: "primary", value: <GSButton buttonIcon={faTimesCircle} onClick={(e) => {removeLink?.(id); e?.stopPropagation?.()}} /> },
          ],
        },
      ],
    }

    return [
      { ...icon },
      {
        ...link
      },
      {
         ...remove
      },
    ];
  };
  return (
    <organization-link-item>
      <GSInfoGroup type="list-item grey selectable x-large-pad" dataGroups={getInfoGroup()} />
    </organization-link-item>
  );
};

export default OrganizationLinkItem;
